module.exports = __webpack_public_path__ + "static/media/upper_active.7852a401.svg";